
export default class NetworkError extends Error {
    constructor(message, errorObject = null) {
        super(message)
        this.name = 'NetworkError'
        this.errorObject = errorObject
    }
}
